import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaymentEwalletTokenService {
    private httpBackend = inject(HttpBackend);
    private http: HttpClient;
    constructor() {
        this.http = new HttpClient(this.httpBackend);
    }
    registerCardDetails(url: string, cardDetails: any, cardToken?: string): Promise<HttpResponse<any> | null> {
        if (!this.isNullOrEmpty(url)) {
            let headers = new HttpHeaders({
                'Content-Type': 'application/json',
            });
            if (cardToken) {
                headers = headers.append('token', cardToken);
            }
            return firstValueFrom(
                this.http.post<any>(url, cardDetails, {
                    headers,
                    observe: 'response',
                }),
            );
        }
        return Promise.resolve(null);
    }
    private isNullOrEmpty(str: string | null | undefined): boolean {
        return !str || str.trim() === '';
    }
}
